import React, { Component } from 'react';
import Card from '../components/Card';
import SearchBox from '../components/SearchBox';
import ErrorBoundry from '../components/ErrorBoundry';
import './App.css';
import Scroll from '../components/Scroll';

class App extends Component {
	constructor() {
		super()
		this.state = {
			facts: '',
			searchchange: ''
		}
	}
	onSearchChange = (date) => {
		this.setState({ searchchange: date.target.value, facts: ''})
			if (date.target.value.length === 6) {
				const dateUrl = new URL('http://numbersapi.com/' + this.state.searchchange + '/date');
				fetch(dateUrl)
				.then(response => response.text())
				.then(text=> 
					this.setState({ facts: text}));
			} else {
				this.setState({ facts: "Input date in format 'mm/dd/'"})
			}

		};

	onClick = (event) => {
		this.setState({ searchchange: '', facts: ''})
		fetch('http://numbersapi.com/random/year')
		.then(response => response.text())
		.then(text=> 
			this.setState({ facts: text}));
	}

	render() {
		const { searchchange, facts } = this.state; 
		return (
			<div className='tc'>
				<h1 className='f1'>TODAY IS A SPECIAL DAY!</h1>
				<SearchBox searchChange={this.onSearchChange} Click={this.onClick}/>
				<Scroll>
					<ErrorBoundry>
						<Card date={searchchange} fact={facts}/>
					</ErrorBoundry>
				</Scroll>
			</div>
		);
	}
}

export default App;